<!--
    班级管理-班级二维码
    功能：展示当前班级的二维码
-->
<template>
  <div class="dialog-wap">
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="班级二维码"
      width="650px"
    >
      <div
        v-loading="loading"
        class="dialog-content">
        <!-- <div class="left">
          <el-image
            :src="circleUrl"
            :fit="fit"
            class="code"/>
            <canvas id="class_code" width="250" height="444"/>
        </div> -->
        <canvas
          ref="classCode"
          width="320"
          height="567"/>
        <div
          id="qrCode"
          style="display: none"/>
        <div
          class="right">
          <p>1、老师可以通过分享二维码给
          对应学生/学生群，识别二维码
          加入班级；</p>
          <p>2、学生也可以主动在小程序
          【云上互动课堂】
          我的--我的班级--加入班级
          输入班级码主动加入；</p>
          <div class="bottom">
            <el-button
              :loading="downLoading"
              type="primary"
              @click="handlerDown"
            >保存图片</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';
import FileSaver from 'file-saver';
import QRCode from 'qrcodejs2';
import h5Url from '@/utils/h5Url';
export default {
  name: 'ClassCodeDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    classInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      downLoading: false,
      codeBg: require('@/assets/images/class_code_bg.png'),
    };
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.setCanvas(this.classInfo);
    }, 500);
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    // 绘制图片
    setCanvas(data) {
      const qrUrl = `${h5Url}/class_code/join?classesCode=${this.classInfo.classes_code}`
      new QRCode('qrCode', {
        text: qrUrl,
        width: 700,
        height: 700,
        colorDark: '#333333',
        colorLight: '#ffffff',
        // correctLevel: QRCode.CorrectLevel.H,
        correctLevel: 0,
      });
      const myCanvas = document.getElementById('qrCode').getElementsByTagName('canvas')[0];
      const codeUrl = myCanvas.toDataURL('image/png');
      const canvas = this.$refs.classCode;
      canvas.width = 320;
      canvas.height = 567;
      const ctx = canvas.getContext('2d');
      const bgImg = new Image();
      bgImg.src = this.codeBg;
      bgImg.onload = () => {
        ctx.drawImage(bgImg, 0, 0, 1504, 2668, 0, 0, 320, 567);
        this.canvasText(canvas, ctx, `${data.class_name}班级`, '600 19px sans-serif', '#FFEFA4', 0, 40, 'center');
        this.canvasText(canvas, ctx, `${data.class_teacher}老师邀请您加入`, '600 15px  sans-serif', '#ffffff', 0, 70, 'center');
        this.canvasText(canvas, ctx, '随时接收班级通知', '600 15px  sans-serif', '#ffffff', 0, 95, 'center');
        const qrImg = new Image();
        qrImg.src = codeUrl;
        qrImg.onload = () => {
          ctx.drawImage(qrImg, 90, 185, 142, 142);
          this.canvasText(canvas, ctx, '长按识别二维码加入班级', '600 14px  sans-serif', '#FF9A36', 0, 354, 'center');
          this.canvasText(canvas, ctx, '班级码', '600 14px  sans-serif', '#999999', 85, 501);
          this.canvasText(canvas, ctx, data.class_num, '600 14px  sans-serif', '#000000', 175, 501);
        };
      };
    },
    canvasText(canvas, ctx, text, fontSzie, color, width, height, align) {
      ctx.font = fontSzie;
      ctx.fillStyle = color;
      if (align === 'center') {
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, canvas.width / 2, height);
      } else {
        ctx.fillText(text, width, height);
      }
    },
    // 下载图片
    handlerDown() {
      this.downLoading = true;
      const canvas = this.$refs.classCode;
      html2canvas(canvas, {
        backgroundColor: null,
        useCORS: true, // 允许图片跨域
        taintTest: true, // 在渲染前测试图片
        timeout: 500, // 加载延时
      }).then((item) => {
        item.toBlob((blob) => {
          FileSaver.saveAs(blob, `${this.classInfo.class_name}班级码.jpeg`);
        });
        this.downLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wap {
  /deep/ .el-dialog__header{
    border-bottom: 1px solid #E9E9E9;
  }
    /deep/ .el-button--primary{
    min-width: auto;
    background: #FF7838!important;
    border-color: #FF7838!important;
  }
}
.dialog-content{
  display: flex;
  .code{
    width: 250px;
  }
  .right{
    margin-left: 40px;
    p{
      color: bottom;
      line-height: 24px;
    }
  }
  .bottom{
    padding: 356px 10px 0 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/ClassManage/components/ClassCodeDialog/index.vue